import Discover from './discover'
import ProductDetails from './productDetails'
import Audit from './audit'
import Store from './store'
import Settings from './settings'
import Billing from './billing'
import WalletFundingHistory from './walletFundingHistory'
import BillingDetails from './billingDetails'
import ClientUsers from './users'

export default [
    Discover,
    ProductDetails,
    Audit,
    Store,
    Settings,
    Billing,
    WalletFundingHistory,
    BillingDetails,
    ClientUsers
]